import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './create_description.less'
import TextBox from 'components/common/text_box'
import Cover from 'components/cover'
import Separator from 'components/common/separator'
import { getI18n } from 'client/i18n'
import { DESCRIPTION_ROWS } from 'shared/lengths'

export const I18N_CONTEXT = 'components/pages/create/pool_description'
const i18n = getI18n(I18N_CONTEXT)

class PoolDescription extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onChangeCover: PropTypes.func,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    gradientColor: PropTypes.string,
    backgroundImage: PropTypes.string,
    backgroundPan: PropTypes.number,
    isAndroid: PropTypes.bool,
  }

  render() {
    const {
      fields: { description },
      backgroundImage,
      backgroundPan,
      gradientColor,
      handleSubmit,
      anyInactiveFieldsTouchedWithError,
      isAndroid,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <div styleName="title">{i18n('title')}</div>
        {!isAndroid && (
          <div>
            <Separator type="dotted" />
            <Cover
              dataNemo="background-image"
              backgroundImage={backgroundImage}
              backgroundPan={backgroundPan}
              gradientColor={gradientColor}
              changeRedirectLocation={{
                pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create/cover`,
              }}
              showHeader={true}
            />
            <Separator type="dotted" />
          </div>
        )}
        <div styleName="description-container">
          <TextBox
            {...description}
            dataNemo="about-pool-description"
            multiline={true}
            rows={DESCRIPTION_ROWS}
            title={i18n('description_title')}
          />
          <div styleName="description-subtitle">
            {i18n('description_subtitle')}
          </div>
        </div>
        <button
          data-pa-click="next"
          className={`vx_btn vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          styleName="btn-done"
          data-nemo="preview-next"
        >
          {i18n('preview')}
        </button>
      </form>
    )
  }
}

export default cssModules(PoolDescription, styles)
